import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import AdBlockDetect from "react-ad-block-detect";
import adBlockLogo from "../../assets/adblock-logo.png";
import { AdBlockDiv } from "./styles.js";

export default function AdBlockAlert() {
	const [show, setShow] = useState(false);

	useEffect(() => {
		const url = document.URL;
		if (url.includes("?adjust_referrer=")) {
			setShow(true);
		}
	}, []);

	return (
		<AdBlockDetect>
			<Modal size="md" show={show}>
				<Modal.Header>
					<Modal.Title>Essa não!</Modal.Title>
				</Modal.Header>
				<Modal.Body
					style={{
						background: "whitesmoke",
						paddingRight: 15,
						paddingLeft: 15,
					}}
				>
					<AdBlockDiv>
						<img src={adBlockLogo} alt="" />
						<p>Notamos que você possui um ad-blocker ativo</p>
						<p>
							Para liberar seus benefícios, pedimos que acesse o
							link pelo seu smartphone <br />
							OU
							<br /> desabilite seu bloqueador de anúncios antes
							de realizar seu login no Portal Trademap
						</p>
						<br />
						<div>
							<p>Para desativar a extensão: </p>
							<p>
								- Clique no ícone do AdBlock, localizado
								à direita da barra de endereços do seu
								navegador
							</p>
							<p>- Um menu drop-down aparecerá na tela</p>
							<p>
								- Na opção “Pausar neste site” clique em
								"Sempre" para desativar o bloqueio da
								publicidade
							</p>
							<p>- Após o clique, a página será recarregada</p>
						</div>
					</AdBlockDiv>
				</Modal.Body>
			</Modal>
		</AdBlockDetect>
	);
}
